import { c as n } from "../../../../index.esm-BeDSGXP5.js";
import { css as e } from "styled-components";
const t = ({ text: o, background: r, border: l, hoverText: d, hoverBackground: s, hoverBorder: a }) => () => /* @__PURE__ */ e([
  "color:",
  ";background-color:",
  ";border-color:",
  ";&:hover{color:",
  ";background-color:",
  ";border-color:",
  ";}"
], o, r, l, d, s, a), i = () => /* @__PURE__ */ e([
  "min-width:0;",
  ""
], n({
  paddingX: [
    0,
    0,
    0
  ],
  paddingY: [
    0,
    0,
    0
  ],
  borderWidth: [
    0,
    0,
    0
  ],
  width: [
    "auto"
  ]
})), x = {
  base: ({ theme: o }) => /* @__PURE__ */ e([
    "",
    " padding:",
    " ",
    ";display:inline-block;cursor:pointer;min-width:256px;border-radius:4px;border-width:2px;border-style:solid;box-sizing:border-box;text-align:center;text-decoration:none;font-family:inherit;box-shadow:0 2px 8px 0 rgba(0,0,0,0.16);&:disabled,&:disabled:hover{cursor:default;box-shadow:none;border-color:rgba(0,0,0,0);}&:hover{box-shadow:none;}",
    ""
  ], n({
    fontSize: [
      "textMediumMobile",
      null,
      "textMediumDesktop"
    ],
    fontWeight: "medium",
    lineHeight: [
      "textMediumMobile",
      null,
      "textMediumDesktop"
    ],
    width: [
      "100%",
      null,
      "auto"
    ]
  }), o.space.sm, o.space.lg, o.components.forms.focusActiveState),
  inherit: () => /* @__PURE__ */ e([
    "",
    ""
  ], n({
    fontSize: [
      "inherit",
      "inherit",
      "inherit"
    ],
    lineHeight: [
      "inherit",
      "inherit",
      "inherit"
    ]
  })),
  small: () => /* @__PURE__ */ e([
    "",
    ""
  ], n({
    fontSize: [
      "textSmallMobile",
      null,
      "textSmallDesktop"
    ],
    lineHeight: [
      "textSmallMobile",
      null,
      "textSmallDesktop"
    ]
  })),
  medium: () => /* @__PURE__ */ e([
    "",
    ""
  ], n({
    fontSize: [
      "textMediumMobile",
      null,
      "textMediumDesktop"
    ],
    lineHeight: [
      "textMediumMobile",
      null,
      "textMediumDesktop"
    ]
  })),
  large: () => /* @__PURE__ */ e([
    "",
    ""
  ], n({
    fontSize: [
      "textLargeMobile",
      null,
      "textLargeDesktop"
    ],
    lineHeight: [
      "textLargeMobile",
      null,
      "textLargeDesktop"
    ]
  })),
  action: ({ theme: o }) => /* @__PURE__ */ e([
    "",
    ""
  ], t(o.componentColors.button.action)),
  confirmation: ({ theme: o }) => /* @__PURE__ */ e([
    "",
    ""
  ], t(o.componentColors.button.confirmation)),
  decision: ({ theme: o }) => /* @__PURE__ */ e([
    "",
    ""
  ], t(o.componentColors.button.decision)),
  destructive: ({ theme: o }) => /* @__PURE__ */ e([
    "",
    ""
  ], t(o.componentColors.button.destructive)),
  secondary: ({ theme: o }) => /* @__PURE__ */ e([
    "",
    ""
  ], t(o.componentColors.button.secondary)),
  textLink: ({ theme: o }) => /* @__PURE__ */ e([
    "",
    " box-shadow:none;text-decoration:underline;&:hover{text-decoration:none;}svg{color:",
    ";}&:hover{svg{color:",
    ";}}"
  ], t(o.componentColors.button.textLink), o.componentColors.button.textLink.icon, o.componentColors.button.textLink.iconHover),
  iconWrapper: () => /* @__PURE__ */ e([
    "",
    ""
  ], n({
    transform: [
      "translate(.4rem, .3rem)",
      null,
      "translate(.5rem, .4rem)"
    ],
    display: "inline-block"
  })),
  textLinkInline: ({ theme: o }) => /* @__PURE__ */ e([
    "",
    " box-shadow:none;text-decoration:underline;&:hover{text-decoration:none;}",
    ""
  ], t(o.componentColors.button.textLink), i),
  secondaryLink: ({ theme: o }) => /* @__PURE__ */ e([
    "",
    " box-shadow:none;text-decoration:underline;&:hover{text-decoration:none;}"
  ], t(o.componentColors.button.secondaryLink)),
  secondaryLinkInline: ({ theme: o }) => /* @__PURE__ */ e([
    "",
    " box-shadow:none;text-decoration:underline;&:hover{text-decoration:none;}",
    ""
  ], t(o.componentColors.button.secondaryLink), i)
};
export {
  x as default
};
